function offsetTop(element) {
  if (!element.getClientRects().length) {
    return 0;
  }

  const rect = element.getBoundingClientRect();
  const win = element.ownerDocument.defaultView;

  return rect.top + win.pageYOffset;
}

export default offsetTop;



// WEBPACK FOOTER //
// ./app/javascript/packs/modules/offsetTop.js